<template lang="html">

  <form id="formContacto" class="formulario-contacto contratacion-part" @submit.prevent="validateBeforeSubmit" enctype="multipart/form-data">

    <div class="contenedor-intro">
      <h3>Si quieres que uno de nuestros asesores te realice un estudio personalizado ponte en contacto con nosotros y
        estudiaremos tu caso para ver qué es lo mejor para tu negocio.</h3>
    </div>

    <div class="contratacion-part row-start ais">

      <h4 class="selector-suministro-title">Estoy interesado en:</h4>
      <selector-suministro></selector-suministro>

      <div class="left">

        <div class="contenedor-input -full"
          :fill="!!data.empresa" :error="(errors.has('empresa') && clicked)" @click="focus('empresa')">
          <input type="text" class="input-text"
            v-validate="'required'"
            v-model="data.empresa"
            autocomplete="organization"
            name="empresa" />
          <label for="">Nombre de la empresa*</label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('empresa') }}</span>
        </div>



        <div class="contenedor-input -full"
          :fill="!!data.nombre" :error="(errors.has('nombre') && clicked)" @click="focus('nombre')">
          <input type="text" class="input-text"
            v-validate="'required'"
            v-model="data.nombre"
            autocomplete="name"
            name="nombre" />
          <label for="">Nombre y apellidos del contacto*</label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
        </div>

        <div class="contenedor-input -full"
          :fill="!!data.telefono" :error="(errors.has('telefono') && clicked)" @click="focus('telefono')">
          <input type="text" class="input-text"
            v-validate="'required|length:9'"
            v-model="data.telefono"
            name="telefono" />
          <label for="">Teléfono*</label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('telefono') }}</span>
        </div>

        <div class="contenedor-input -full"
          :fill="!!data.email" :error="(errors.has('email') && clicked)" @click="focus('email')">
          <input type="text" class="input-text"
            v-validate="'required|email'"
            v-model="data.email"
            name="email" />
          <label for="">Email*</label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
        </div>



      </div>

      <div class="right">
        <div class="contenedor-input -full textarea" :fill="!!data.mensaje" :error="(errors.has('mensaje') && clicked)">
          <textarea name="mensaje" v-model="data.mensaje"></textarea>
          <label for="">Mensaje</label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('mensaje') }}</span>
        </div>
      </div>

      <div class="bottom">


        <h4 class="-orange">¿Quieres un presupuesto más personalizado?</h4>
        <h4 class="-orange">Adjuntanos tu última factura y realizaremos el estudio en cuestión de horas.</h4>

        <div class="contenedor-adjunto row-start" v-for="file in filecounts+1">
          <input type="file" @change="getImageFile" :id="'file'+file" name="factura[]" :pos="file" multiple>
          <div class="contenedor-input -labeled column-start" :fill="!!filename[file-1]" :error="errors.has('file')">
            <input type="text" :id="'text'+file" fill="false">
            <label for="">Adjunta tu factura actual</label>
          </div>
          <a class="btn -skull-orange -gray-c">Adjuntar</a>
          <span class="error">{{ errors.first('file') }}</span>
        </div>


        <a title="Añadir otro fichero" class="add-fichero" @click="filecounts++" v-if="filename.length == filecounts+1">Añadir otro fichero</a>

        <div class="contenedor-check">
          <input type="checkbox" id="politica" v-validate="'required'" name="politica" v-model="data.politica">
          <label for="politica">He leído y acepto la <router-link :to="$t('enlaces.politica_privacidad')" rel="noopener" target="_blank">política de privacidad</router-link></label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
        </div>


        <div class="contenedor-check">
          <input type="checkbox" id="comunicaciones" name="comunicaciones" v-model="data.newsletter">
          <label for="comunicaciones">Acepto recibir emails con información y promociones de Iner Energía</label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('comunicaciones') }}</span>
        </div>

        <input type="hidden" name="estado" value="0">
        <input type="hidden" name="fuente" value="empresa">

        <div class="contenedor-boton">

          <button class="btn -degree" :loading="loading">{{$t('formulario.enviar')}}</button>

          <div class="result-ok row-center" :enviado="enviado">

            <span class="tick">
              <img src="/static/img/tick.svg" alt="">
            </span>


            <h5>¡Nos pondremos en contacto contigo lo antes posible!</h5>

          </div>

        </div>

      </div>

    </div>

  </form>

</template>

<script lang="js">


  import Vue from 'vue';
  import VeeValidate from 'vee-validate';

  import selectorsuministro from '@/components/parts/selector-suministro';

  Vue.use(VeeValidate);

  import {mapGetters, mapActions} from 'vuex'

  export default  {
    name: 'formulario',
    data() {
      return {
        clicked : false,
        loading : false,
        enviado : false,
        filecounts : 0,
        added : false,
        file : '',
        filename : [],
        data :{
          asunto : '',
          nombre : '',
          tipo_empresa : '',
          telefono : '',
          email : '',
          mensaje : '',
          politica : '',
          terminos : '',
          newsletter : '',
          empresa : ''
        }
      }
    },
    components : {
      'selector-suministro' : selectorsuministro
    },
    methods: {
      ...mapActions(['sendContacto']),
      validateBeforeSubmit : function(){
        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          if(canSend){
            this.loading = true;
            var formData = new FormData($('#formContacto')[0]);
            this.sendContacto(formData)
            .then(result =>{
              this.setsendend();
            });
          }
        });
      },
      setsendend(){
        this.enviado = true;
        this.data ={};
        this.file = '';
        this.filename = [];
        this.loading = false;
        this.clicked = false;
        this.filecounts = 0;
        $("#text1").attr("fill",'');
        $("#text1").val('');
      },
      focus(where){
        document.querySelector(`*[name=${where}]`).focus();
        document.querySelector(`*[name=${where}]`).click();
      },
      getImageFile(event){
        
        let files = event.srcElement.files;
        let src = '';
        let pos = Number(event.target.getAttribute('pos'));

        if(files.length != 0){
          for (let i = 0; i < files.length; i++) {
            (i == 0) ? src += files[i].name : src += ', '+files[i].name;
          }
        }
    
        $("#text"+pos).val(src);
        $("#text"+pos).attr("fill",true);

        this.filename.push(src);
      },
    }
  }
</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';

  .contenedor-boton{
    position: relative;
    overflow: hidden;
  }

  .formulario-contacto{
    margin-top: 0;
    
    h4{
      text-align: left;
      &:first-of-type{
        margin-top:20px;
      }
    }

  }

  .result-ok{
    position: absolute;
    left: -100%;
    top: 0%;
    width: 100%;
    height: 100%;
    transition: .8s;
    transition-timing-function: ease-in-out;
    justify-content: flex-start;
    z-index: 3;
    background: white;

    &[enviado="true"]{
      transform: translateX(100%);
    }

    .tick{
      background: $degree;
      width: 40px;
      height: 40px;
      line-height: 40px;
      display: inline-block;
      text-align: center;
      border-radius: 50%;
    }

    h5{
      margin-bottom: 0;
      font-weight: 800;
      margin-left: 30px;
      font-size: 22px;
      color: $dark;
      max-width: calc(100% - 70px);
      height: 40px;
      line-height: 40px;
      text-align: left;
    }

  }

  .contenedor-adjunto{

    position: relative;
    align-items: center;
    max-width: 100%;
    margin-top: 10px;
    padding-left: 100px;
    padding-top: 20px;
    padding-bottom: 20px;
    background: url("/static/img/icono-factura.webp") center left/80px no-repeat;

    input[type="file"]{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 4;
      opacity: 0;
      cursor: pointer;
    }

    .error{
      font-size: 12px;
      color: $rojo;
      display: inline-block;
      width: 100%;
      padding-left: 35px;
    }

    .contenedor-input{
      height: 60px;
      border:1px solid $purple;
      background: white;
      border-radius: 30px;
      width: 100%;
      max-width: calc(100% - 180px);
      margin-right: 20px;
      margin-bottom: 0;
      padding-bottom: 5px;
      justify-content: flex-end;

      &[fill=true]{
        border:1px solid $orange;
      }

      &[error=true]{
        border:1px solid $rojo;
        label{
          color: $rojo!important;
        }
      }

      label{
        font-size: 18px;
        color:$dark;
        position: absolute;
        left: 0;
        top: 0;
        font-weight: 800;
        height: 60px;
        padding-left: 30px;
        line-height: 60px;
        pointer-events: none;
        transition: .5s;
        width: 100%;
        text-align: left;
      }

      input{
        height: 30px;
        width: 100%;
        max-width: 100%;
        outline: none;
        font-size: 18px;
        font-weight: 800;
        margin-bottom: 0;
        padding-bottom: 0;
        padding-left: 30px;
        margin-left: 10px;
        background: transparent;
        border:none;
        cursor: pointer;
        min-width: 0;
        margin-bottom: 0;
      }


      input:focus + label,
      input[fill=true] + label{
        font-size: 14px;
        color: $orange;
        transform: translateY(-15px);

      }
    }

    .instrucciones{
      font-size: 10px;
      width: 100%;
      display: inline-block;
      margin-top: 5px;
      text-align: left;
    }

  }

  
  .add-fichero{
      text-decoration: underline;
      width:100%;
      display: inline-block;
      text-align: left;
      margin-bottom: 50px;
    }

    .contenedor-adjunto + .contenedor-check{
      margin-top: 30px;
    }

  @media screen and (max-width: 700px){
    .contenedor-adjunto{
      background: none;
      padding-left: 0;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .contenedor-adjunto .contenedor-input{
      max-width: 100%;
      margin-bottom: 20px;
    }
    
    .result-ok h5{
      font-size: 16px;
      line-height: 1.1em;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      justify-content: flex-start;
      -ms-align-items: center;
      align-items: center;
    }

  }
  
  @media screen and (max-width: 500px){
    .result-ok .tick{
      width: 30px;
      height: 30px;
      line-height: 30px;
    }

    .result-ok h5{
      margin-left: 10px;
      font-size: 16px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/view-parts/empresas/formulario.vue